import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, QueryList, TemplateRef, ViewChildren } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TAIGA_UI_MODULES } from 'app/@taiga-modules';
import { selectDatesAndAccupancy, selectHotelBookingData, selectMainImage, selectRoomNameTranslation } from 'app/widget/state';
import { DatesAndAccupancy, ENGINES_TRANSLATIONS, HotelBookingDataDetails } from 'app/widget/state/index.types';
import moment from 'moment';
import { OccupancyInfoComponent } from '../occupancyInfo/occupancyInfo.component';
import { CurrencyExchangePipe, CustomTranslatePipe, RemoveWhitespacePipe } from 'app/widget/index.pipes';
import { TuiScrollbar, tuiScrollbarOptionsProvider } from '@taiga-ui/core';
import { BookingPolicyService } from 'app/widget/services/bookingPolicy.service';
import { fadingTransition } from 'app/route.transition';
import { environment } from '@env/environment';

@Component({
  selector: 'app-ota-details',
  standalone: true,
  imports: [
    CommonModule, 
    ...TAIGA_UI_MODULES, 
    RouterLink, 
    TranslateModule, 
    OccupancyInfoComponent, 
    CustomTranslatePipe, 
    CurrencyExchangePipe,
    RemoveWhitespacePipe
  ],
  providers: [
    // tuiScrollbarOptionsProvider({
    //   mode: 'hover',
    // }),
  ],
  templateUrl: './otaDetails-v3.component.html',
  styleUrl: './otaDetails.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadingTransition,
  ]
})
export class OtaDetailsComponent implements AfterViewInit{

  store$ = inject(Store);
  route = inject(ActivatedRoute);
  bookingPolicy = inject(BookingPolicyService);
  BookingPolicyService = BookingPolicyService
  selectHotelBookingData$ = this.store$.select(selectHotelBookingData)
  selectdatesAndAccupancy$ = this.store$.select(selectDatesAndAccupancy)

  selectedOTATemplate!: TemplateRef<any>;
  @ViewChildren('navItem') listItems!: QueryList<ElementRef>;

  TRANSLATIONS = ENGINES_TRANSLATIONS

  ngAfterViewInit() {
    // Get the first item and trigger click
    if (this.listItems.length > 0) {
      setTimeout(() => {
        this.listItems.first.nativeElement.click();
      }, 100);
    }
  }
  
  getImage(code_room: number){
    return this.store$.select(selectMainImage({code_room}))
  }

  getLink(data: HotelBookingDataDetails, datesAndAccupancy: DatesAndAccupancy){
    const startDate = moment(datesAndAccupancy.range.from).format('YYYY-MM-DD')
    return `${environment.captureUrl}/html/scroll_in_capture?devise=${data.currency}&idEtab=${data.hotel_id}&engine=${data.ota}&id=${data.serial}&lang=${this.route.snapshot.queryParams['lang']}&start=${startDate}&uid=${data.uid}`
  }

  getRoomName(roomId: number){
    return this.store$.select(selectRoomNameTranslation({roomId}))
  }
}
